<template>
  <div class="incentives">
    <navbar />

    <div class="page-intro page-intro--v2 d-flex justify-content-center align-items-center">
      <h1 class="page-intro__title" v-t="'experiences'"></h1>
    </div>

    <b-container class="mb-5">
      <h2 class="page-heading">{{options.experiences.length}} {{ $t('pageExperiences.title') }}</h2>

      <b-row class="mb-5">
        <b-col cols="12" lg="9" class="mx-auto">
          <h2 v-t="'pageExperiences.description'"></h2>
          <p class="mt-2">
            <small v-html="$t('offers.payment')"></small>
          </p>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" md="6" lg="4" v-for="data in options.experiences" v-bind:key="data.id" class="mb-4">
          <Experience v-bind:image="data.image" v-bind:name="data.name" v-bind:description="data.description" v-bind:price="data.price" v-bind:companies="data.companies" v-bind:routing="data.routing" />
        </b-col>
      </b-row>
    </b-container>

    <Footer />
  </div>
</template>

<script>
  import Navbar from './home/sections/Navbar.vue'
  import Experience from '@/components/Experience.vue'
  import Experiences from '@/data/experiences.json'
  import Footer from '@/components/Footer.vue'

  export default {
    name: 'Incentives',
    title: 'Experiências',
    data() {
      return { options: { experiences: Experiences } }
    },
    components: {
      Navbar,
      Experience,
      Footer
    }
  }
</script>